/**
 * Header
 */

/* Debounce function that accepts a function and a delay */
const debounce = (fn, delay = 100) => {
  let timeoutId
  return function (...args) {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      fn(...args)
    }, delay)
  }
}

class CustomHeader extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    setTimeout(() => {
      this.init()
    }, 100)
  }
  init() {
    this.animation = null
    this.bgAnimation = null
    this.setHeaderHeight()
    this.mobileDrawer()
    this.megaDesktop()
    this.searchFocus()
    this.headerHeightObservers()
    const that = this
    setTimeout(function () {
      that.accountFocus()
    }, 1000)

    window.addEventListener("resize", () => this.setHeaderHeight())
  }
  searchFocus() {
    const searchCloseButton = document.querySelector(".search-bar-close");
    const searchTriggerButton = document.querySelector("#search_btn_nav");
    const searchBar = document.querySelector(".search-bar");

    if (searchCloseButton && searchTriggerButton && searchBar) {
        const handleFocusTrap = (event) => {
            const isSearchBarOpen = document.body.classList.contains("search-bar-open");

            if (isSearchBarOpen && event.key === "Tab") {
                const focusableElements = searchBar.querySelectorAll(
                    'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
                );
                const focusableArray = Array.from(focusableElements);

                if (focusableArray.length > 0) {
                    const firstFocusableElement = focusableArray[0];
                    const lastFocusableElement = focusableArray[focusableArray.length - 1];

                    if (event.shiftKey) {
                        // Shift + Tab
                        if (document.activeElement === firstFocusableElement) {
                            event.preventDefault();
                            lastFocusableElement.focus();
                        }
                    } else {
                        // Tab
                        if (document.activeElement === lastFocusableElement) {
                            event.preventDefault();
                            firstFocusableElement.focus();
                        }
                    }
                } else {
                    event.preventDefault();
                }
            }
        };

        document.addEventListener("keydown", handleFocusTrap);

        // Handle closing modal and resetting focus
        searchCloseButton.addEventListener("click", () => {
            document.body.classList.remove("search-bar-open");
            
            setTimeout(() => {
                searchTriggerButton.focus();
                // Announce focus change for NVDA
                searchTriggerButton.setAttribute("aria-live", "assertive");
            }, 50);
        });
    }
}


  accountFocus() {
    const accountCloseButton = document.querySelectorAll(".mini-account-close")[0]
    const accountTriggerButton = document.querySelectorAll(".hdr--desktop .hdr__account")[0]
    const registerTriggerButton = document.querySelectorAll(".mini-account-register-trigger")[0]
    const loginTriggerButton = document.querySelectorAll(".mini-account-login-trigger")[0]
    const registerTitle = document.getElementById("mini-account-register-title")
    const loginTitle = document.getElementById("mini-account-login-title")
    const registerPanel = document.querySelectorAll(".mini-account-register")[0]
    const loginPanel = document.querySelectorAll(".mini-account-login")[0]
    const popup = document.querySelectorAll(".mini-account")[0]
    const body = document.body

    if (accountCloseButton && accountTriggerButton && popup) {
      const focusOnAccountClose = () => {
        setTimeout(() => {
          accountCloseButton.focus()
        }, 100)
      }

      const focusOnAccountTrigger = () => {
        setTimeout(() => {
          accountTriggerButton.focus()
        }, 100)
      }

      accountTriggerButton.addEventListener("click", focusOnAccountClose)

      accountCloseButton.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          focusOnAccountTrigger()
        }
      })

      const handleTabSwitch = (triggerButton, targetPanel, otherPanel, targetTitle) => {
        triggerButton.addEventListener("click", () => {
          setTimeout(() => {
            targetPanel.classList.add("active")
            otherPanel.classList.remove("active")
            targetTitle.focus()
          }, 100)
        })

        triggerButton.addEventListener("keydown", (event) => {
          if (event.key === "Enter") {
            setTimeout(() => {
              targetPanel.classList.add("active")
              otherPanel.classList.remove("active")
              targetTitle.focus()
            }, 100)
          }
        })
      }

      if (registerTriggerButton && registerTitle) {
        handleTabSwitch(registerTriggerButton, registerPanel, loginPanel, registerTitle)
      }

      if (loginTriggerButton && loginTitle) {
        handleTabSwitch(loginTriggerButton, loginPanel, registerPanel, loginTitle)
      }

      const getFocusableElements = () => {
        const elements = Array.from(
          popup.querySelectorAll(
            'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
          )
        )
        return elements
      }

      const handleTabKey = (event) => {
        if (event.key === "Tab") {
          const focusableElements = getFocusableElements()
          const firstFocusable = focusableElements[0]
          const lastFocusable = focusableElements[focusableElements.length - 1]

          if (event.shiftKey) {
            if (document.activeElement === firstFocusable) {
              event.preventDefault()
              lastFocusable.focus()
            }
          } else {
            if (
              document.activeElement === lastFocusable ||
              document.activeElement === registerTriggerButton
            ) {
              event.preventDefault()
              firstFocusable.focus()
            }
          }
        }
      }

      document.addEventListener("keydown", handleTabKey)
      if (registerTitle) {
        registerTitle.setAttribute("tabindex", "0")
      }
      if (loginTitle) {
        loginTitle.setAttribute("tabindex", "0")
      }
    }
  }

  setHeaderHeight() {
    this.headerHeight = `${this.offsetHeight}px`
    this.bannerAnnouncement = this?.firstElementChild?.offsetHeight
      ? `${this?.firstElementChild?.offsetHeight}px`
      : "0px"

    console.log(this)

    document
      .querySelector("body")
      .style.setProperty("--hdr-announcement-height", this.bannerAnnouncement)
    document.querySelector("body").style.setProperty("--hdr-height", this.headerHeight)

    if (this.hasAttribute("data-enable-transparent")) {
      document.querySelector("main").style.marginTop = this.bannerAnnouncement
    }
  }

  /**
   * Initializes observers for changes in the header's height.
   * This method helps in adjusting the layout or performing actions based on the header's size.
   */
  headerHeightObservers() {
    // Listen to window resize events with a debounced handler to prevent excessive updates.
    window.addEventListener("resize", debounce(this.setHeaderHeight.bind(this), 100))

    // Create a ResizeObserver to watch for changes in the header's height.
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        // Check if the header's height has changed.
        if (this.offsetHeight !== entry.contentRect.height) {
          // Update the header's height if it has changed.
          this.setHeaderHeight()
        }
      }
    })

    // Start observing the header element for size changes.
    resizeObserver.observe(this)
  }

  mobileDrawer() {
    function toggleOpenAttribute(triggerSelector, parentSelector, ariaSelector = false) {
      const triggers = document.querySelectorAll(triggerSelector);
  
      triggers.forEach((trigger) => {
        trigger.addEventListener("click", function () {
          const parentWrapper = this.closest(parentSelector);
          const srOnlySpan = this.querySelector(".sr-only");
  
          if (parentWrapper) {
            const isOpen = parentWrapper.hasAttribute("open");
  
            // Toggle the open attribute
            if (isOpen) {
              parentWrapper.removeAttribute("open");
              if (srOnlySpan) srOnlySpan.textContent = "Open Mobile Nav";
            } else {
              parentWrapper.setAttribute("open", "");
              if (srOnlySpan) srOnlySpan.textContent = "Close Mobile Nav";
            }
  
            // Set aria-expanded based on the open state
            if (ariaSelector) {
              this.setAttribute("aria-expanded", !isOpen);
            }
          }
        });
      });
    }
  
    function closeAllOnOverlayOrEscape(overlaySelector, parentSelector, triggerSelector) {
      const overlays = document.querySelectorAll(overlaySelector);
      const triggers = document.querySelectorAll(triggerSelector);
  
      function closeParentElements() {
        document.querySelectorAll(parentSelector).forEach((parent) => {
          if (parent.hasAttribute("open")) {
            parent.removeAttribute("open");
            triggers.forEach((trigger) => {
              const srOnlySpan = trigger.querySelector(".sr-only");
              if (srOnlySpan) srOnlySpan.textContent = "Open Mobile Nav";
              trigger.setAttribute("aria-expanded", "false");
              trigger.focus(); // Return focus to the trigger button
            });
          }
        });
      }
  
      overlays.forEach((overlay) => {
        overlay.addEventListener("click", closeParentElements);
      });
  
      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
          closeParentElements();
        }
      });
    }
  
    // Initialize the toggle for the main nav
    toggleOpenAttribute(".hdr__nav_trigger", ".hdr__mobile__nav__wrapper", true);
  
    // Initialize the toggle for all sub nav items
    toggleOpenAttribute(".hdr__sub_nav_trigger", ".hdr__mobile__sub_nav__wrapper", true);
  
    // Close on overlay click or Escape key press
    closeAllOnOverlayOrEscape(
      "[data-background-overlay]",
      ".hdr__mobile__nav__wrapper",
      ".hdr__nav_trigger"
    );
    closeAllOnOverlayOrEscape(
      "[data-background-overlay]",
      ".hdr__mobile__sub_nav__wrapper",
      ".hdr__sub_nav_trigger"
    );
  }
  
  megaDesktop() {
    this.megaMenuItems = this.querySelectorAll("[data-mega-item]")
    this.allMenuItems = this.querySelectorAll("[data-menu-item]")

    const setMenuEvents = () => {
      this.allMenuItems.forEach((item) => {
        item.addEventListener("mouseleave", () => handleMegaMenuExit())
        item.addEventListener("mouseenter", (event) => handleMegaMenuEnter(event))
        item.addEventListener("keyup", (event) => handleKeyboardKeyUp(event))
        item.addEventListener("focus", () => handleMegaMenuExit())

        const menuToggleButton = item.querySelector(".menu-toggle-button")
        if (!menuToggleButton) return

        menuToggleButton.addEventListener("click", (event) => handleMouseClick(event))
        menuToggleButton.addEventListener("keydown", (event) => handleKeyboardKeyDown(event))
      })
    }

    const handleKeyboardKeyDown = (event) => {
      if (event.key.toUpperCase() === "ENTER" || event.key === " ") {
        event.preventDefault()
        const parentElement = event.target.closest("li")

        return parentElement.dataset.active === "false"
          ? handleMegaMenuEnter(event, parentElement)
          : handleMegaMenuExit()
      }
    }

    const handleMouseClick = (event) => {
      event.preventDefault()
      const parentElement = event.target.closest("li")

      return parentElement.dataset.active === "false"
        ? handleMegaMenuEnter(event, parentElement)
        : handleMegaMenuExit()
    }

    const handleKeyboardKeyUp = (event) => {
      if (event.code.toUpperCase() !== "ESCAPE") return
      handleMegaMenuExit()
    }

    const handleMegaMenuEnter = (event, parentElement) => {
      const { target } = event

      if (target.children[0].dataset.megaItem) {
        const menuToggleButton = target.querySelector(".menu-toggle-button")
        const correspondingMegaMenu = this.querySelector(
          `[data-mega-menu="${target.children[0].dataset.megaItem}"]`
        )

        correspondingMegaMenu.setAttribute("data-show", true)
        target.setAttribute("data-active", true)
        menuToggleButton.setAttribute("aria-expanded", true)
      } else if (target.dataset.megaItem) {
        const correspondingMegaMenu = this.querySelector(
          `[data-mega-menu="${target.dataset.megaItem}"]`
        )

        correspondingMegaMenu.setAttribute("data-show", true)
        parentElement.setAttribute("data-active", true)
        target.setAttribute("aria-expanded", true)
      }
    }

    const handleMegaMenuExit = () => {
      this.allMenuItems.forEach((menuItem) => {
        menuItem.setAttribute("data-active", false)

        const menuToggleButton = menuItem.querySelector(".menu-toggle-button")
        const correspondingMegaMenus = this.querySelectorAll(`[data-mega-menu]`)

        menuToggleButton.setAttribute("aria-expanded", false)
        correspondingMegaMenus.forEach((megaMenus) => {
          megaMenus.setAttribute("data-show", false)
        })
      })
    }

    setMenuEvents()
  }
}

customElements.define("custom-header", CustomHeader)
